define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/aspect",
	"dojo/dnd/common",
	"dojo/dnd/Manager",
	"dojo/dom-class",
	"csi",
	"csi/_base/underscore",
	"csi/action",
	"csi/def",
	"csi/def/Action",
	"csi/def/Actions",
	"csi/html",
	"csi/widget/DndSource"
], function(declare, lang, aspect, dnd, dndManager, domClass, csi, _, csiAction, def, Action, Actions, html, DndSource) {

	//	var	_DnDHandler = declare(null, {
	//		// Boolean: allow multiple selections
	//		allowMultiple: false,
	//
	//		// String: action controller to process drop
	//		controller: "",
	//
	//		// String: CSS to add to view to control styling
	//		css: "",
	//
	//		// Boolean: dndSource should place dropped items in front of other items	
	//		dropInFront: true,
	//	
	//		canDrag: function(ctx) {
	//			// summary: determine if particular node can be dragged
	//			return true;
	//		},
	//
	//		isAppropriateFor: function(/*csi.view.Widget*/view) {
	//			// summary: determine if this handler is appropriate for given view
	//			return false;
	//		}
	//	});

	return declare(null, {
		// Boolean: disable drag and drop for view
		//dndRestrict: false,

		// Action: action to render dnd handles
		//_dndAction: null,

		// _DnDHandler: handler in use for view
		//_dndHandler: null,

		// DndSource[]: DnD sources for view which contain items (multiple when grouped view, otherwise just one)
		//_dndSources: null,

		// String[]: unique id(s) for identifying an item in a view so that items cannot be dropped across views
		//_dndTypes: null,

		// csi.def.Actions class which can be overridden
		actionsClass: Actions,

		// Object[]: provides available handlers for Dnd, can be overridden
		dndHandlers: null,

		/**
		 * Extension point to recalculate target drop position
		 * @param {boolean} before
		 * @param {DndSource} source
		 * @param {Event} e
		 * @return {Object}
		 */
		allowDropping: function(before, source, e) {
			return {
				targetBefore: before,
				targetNode: source.current,
			};
		},

		cleanupDnd: function() {
			//summary: extension point to cleanup operations after canceling or dropping avatar
		},

		destroy: function() {
			// summary: cleanup sources when destroyed
			this._dndCleanup();
			this.inherited(arguments);
		},


		getDndSourceNodes: function() {
			//summary: extension point to return the drag and drop root node
		},

		getDndAction: function() {
			// initialize and return DnD action
			var h = this._dndHandler;
			return lang.mixin(new Action(), {
				classController: h.controller,
				m_accessAction: (ctx) => h.canDrag(ctx),
				m_class: "fas fa-arrows-alt",
				m_id: "Dnd",
				m_typeControl: def.ACTION_ICON,
				m_drawAction: (ctx, action, refNode, bToggled) => {
					// wrap font awesome icon in span as it disables drag and drop (I think because converting to svg)
					const span = html.create("span", {
						className: "dojoDndHandle"
					}, refNode);

					action.toHtmlControl(ctx, span, bToggled);

					return span;
				}
			});
		},

		onDndDragExtension: function(source, e) {
			//Extension point for changing the current Target Node
		},

		postCreate: function() {
			// summary: add aspects to control Dnd behavior
			this.inherited(arguments);
			this._dndTypes = [dnd.getUniqueId()];
			this.own(
				aspect.before(this, "postAction", lang.hitch(this, this._dndPostAction))
			);
		},

		isDndAllowed: function() {
			//summary: extension point for disabling or enabling drag and drop
			return true;
		},

		isDndAvailable: function() {
			// extension point for enabling or disabling Dnd
			return !this.dndRestrict;
		},

		isDndHorizontal: function() {
			//summary: extension point for dnd vertical or horizontal
			return false;
		},

		onCreateDndSource(source) {
			// summary: extension point to customize source when created
		},

		/**
		 * Extension point for processing selections
		 * @param {DndSource} source
		 * @param {Event} e
		 */
		onDndSelectExtension(source, e) { },

		/**
		 * Extension point for when dropping the avatar on the source
		 * @param {Object} source - source
		 * @param {Array} nodes - the selected DOM nodes
		 * @return {boolean} - return false if drop should be cancelled
		 */
		onDndDropExtension(source, nodes) {
			return true;
		},

		/**
		 * Extension point for cancelling the DnD operation
		 * @param {DndSource} source
		 */
		onDndCancelExtension(source) { },

		/**
		 * Extension point for when mouse over event on dojoDndItem
		 * @param {Event} e
		 */
		onMouseOverExtension(e) { },

		/**
		 * Extension point for when mouse up event on dojoDndItem
		 * @param {DndSource} source
		 * @param {Event} e
		 */
		onDndMouseUpExtension(source, e) { },

		/**
		 * Extension point for starting the DnD operation
		 * @param {DndSource} source
		 */
		onDndStartExtension(source) { },

		dndAvatarCreator: function(item, hint) {
			// summary: over ride avatar creation
			var domNode = item.cloneNode(true);
			domNode.id = dnd.getUniqueId();
			if (hint == "avatar") {
				domNode = this.getFormattedAvatar(domNode, item);
			}

			return {node: domNode, data: domNode, type: this._dndTypes};
		},

		getFormattedAvatar: function(domNode) {
			// summary: extension point to over ride avatar creation
			return domNode;
		},

		_dndBuildResult: function(/*DOMNode*/refNode) {
			// summary: register rendered items with Dnd source
			if (!refNode || !this._dndHandler) {
				return;
			}

			// initialize sources if not done already
			var types = this._dndTypes;

			if (!this._dndSources) {
				var nodes = this.getDndSourceNodes();
				var self = this;

				this._dndSources = _.map(nodes, function(domNode) {
					// in grouped view, we want source to be table cell (td) which is direct parent of content node
					var s = new DndSource(this.bPlot ? domNode.parentNode : domNode, {
						accept: types,
						allowDropping: lang.hitch(this, this.allowDropping),
						cleanupDnd: lang.hitch(this, this.cleanupDnd),
						delay: 10,
						dropInFront: self._dndHandler.dropInFront,
						dropParent: domNode,
						exemptTargetTag: "A",
						horizontal: self.isDndHorizontal(),
						onDndDragExtension: lang.hitch(this, this.onDndDragExtension),
						onDndSelectExtension: lang.hitch(this, this.onDndSelectExtension),
						onDndStartExtension: lang.hitch(this, this.onDndStartExtension),
						onDndCancelExtension: lang.hitch(this, this.onDndCancelExtension),
						onDndDropExtension: lang.hitch(this, this.onDndDropExtension),
						onMouseOverExtension: lang.hitch(this, this.onMouseOverExtension),
						onDndMouseUpExtension: lang.hitch(this, this.onDndMouseUpExtension),
						selfAccept: !this.bPlot,
						singular: !this.allowMultiSelect,
						withHandles: true,

						copyState: function() {
							// no use cases for copying yet
							return false;
						},
						creator: lang.hitch(this, this.dndAvatarCreator),
						enableDndItem: function() {
							return self.isDndAllowed();
						}
					});

					this.onCreateDndSource(s);

					s.csiDropHandle = aspect.after(s, "onDrop", lang.hitch(this, this._dndDrop, s), true);
					return s;
				}, this);

				if (this._dndHandler) {
					// add CSS to view for new handler
					domClass.add(this.domNode, this._dndHandler.css);
				}
			}

			// register item to source that contains refNode
			_.some(this._dndSources, function(s) {
				if (refNode.parentNode == s.dropParent) {
					refNode.id = dnd.getUniqueId();
					s.setItem(refNode.id, {data: refNode, type: types});
					return true;
				}
			});
		},

		_dndCleanup: function() {
			// summary: cleanup DND source
			_.each(this._dndSources, function(s) {
				s.csiDropHandle.remove();
				s.destroy();
			});

			delete this._dndSources;
		},

		_dndDrop: function(/*Source*/target, /*Source*/source, /*Node[]*/nodes, /*Boolean*/copy) {
			// summary: invoke action controller to move nodes to new location - so far copy is not a use case
			var sortedNodes = csi.sort(nodes, function(domNode) {
				return html.getElementIndex(domNode);
			});

			csiAction.invoke(this, this.domNode, this._dndAction, {
				bHold: true,
				dndTarget: target,
				dndSource: source,
				dndNodes: sortedNodes,
			});

			this.resize();
		},

		_dndInitialize: function(/*QueryResults*/results, /*Boolean*/bRefresh) {
			// If touch device detected, Dojo activates touch regime by defining has("touch") - see dojo/has.js
			// In touch regime X and Y offsets of the pointer relative to the dragging object are set to {0, -64} - see dojo/dnd/Manager.js
			// If device has both mouse and touch - it will conflict and mouse dragging will be broken (large vertical offset looks as artifact).
			// Enforcing mouse mode for gallery drag-drop operations, and set offset to 0, because we want dragging cursor to be 
			// at the same point where it was start dragging:
			var manager = dndManager.manager();
			manager.OFFSET_X = 0;
			manager.OFFSET_Y = 0;

			// remove CSS for existing handler
			if (this._dndHandler) {
				this._dndCleanup();
				domClass.remove(this.domNode, this._dndHandler.css);
				this._dndHandler = null;
				this._dndAction = null;
			}

			var dndEnabled = this.isDndAvailable();
			var fd = this.defView.m_formData;

			if (dndEnabled) {
				this._dndHandler = this.dndHandlers.find((handler) => handler.isAppropriateFor(this));

				if (this._dndHandler) {
					this._dndAction = this.getDndAction();
					this._dndAction.resolve();
				}
			}

			this.allowMultiSelect = fd ? !fd.m_bSelectOne : !!this._dndHandler?.allowMultiple;
		},

		_dndPostAction: function() {
			// summary: clear selections after any action
			_.each(this._dndSources, function(s) {
				s.selectNone();
			});
		}
	});
});